import { render, staticRenderFns } from "./SIMDetail.vue?vue&type=template&id=25549565&scoped=true&"
import script from "./SIMDetail.vue?vue&type=script&lang=js&"
export * from "./SIMDetail.vue?vue&type=script&lang=js&"
import style0 from "./SIMDetail.vue?vue&type=style&index=0&id=25549565&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25549565",
  null
  
)

export default component.exports